/* eslint-disable no-console, no-undef */
// src/main.js

import './plugins/jquery'; // sets window.$ and window.jQuery
import 'custom-event-polyfill';
import 'url-polyfill';

import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import Popper from 'popper.js';
import axios from 'axios';
import VueAxios from 'vue-axios';
import Vuelidate from 'vuelidate';
import moment from 'moment';
import VueSimpleAlert from 'vue-simple-alert';
import Errors from './services/Errors';
import App from './App.vue';
import router from './router';
import store from './store';
import configureMsal from './msal/msal';
import i18n from './lang';
import icons from './icons';
import globals from './globals';

Vue.prototype.$moment = moment;

Vue.config.errorHandler = (error) => Errors.onError(error);

Popper.Defaults.modifiers.computeStyle.gpuAcceleration = false;

Vue.config.productionTip = false;
Vue.config.devtools = false;

Vue.use(BootstrapVue);
Vue.use(VueAxios, axios);
Vue.use(Vuelidate);
Vue.use(VueSimpleAlert);

Vue.mixin({
  data: globals,
});

axios.interceptors.request.use(
  async (config) => {
    if (store.state.authorization.userAuthorization) {
      if (store.state.authorization.userAuthorization.token) {
        // console.log('Axios: Adding Authorization header with token:', store.state.authorization.userAuthorization.token);
        // eslint-disable-next-line no-param-reassign
        config.headers.Authorization = `Bearer ${store.state.authorization.userAuthorization.token}`;
      } else {
        console.warn('Axios: No token found in store');
      }
    }
    return config;
  },
  (error) => {
    console.error('Axios: Request error:', error);
    return Promise.reject(error);
  },
);

// console.log('Main: Starting app initialization');
store
  .dispatch('settings/loadSettings')
  .then(() => Vue.nextTick())
  .then(() => {
    const adfsSettings = store.getters['settings/adfsSettings'];
    if (!adfsSettings.clientId) {
      throw new Error('ADFS clientId missing');
    }
    return configureMsal(adfsSettings, router, store);
  })
  .then((authenticationContext) => authenticationContext.initialize().then(() => {
    if (authenticationContext.isAuthenticated()) {
      Vue.prototype.$msal = authenticationContext;
      return authenticationContext.acquireApiToken().then((token) => store.dispatch('authorization/loadAuthorization', {
        token,
        account: authenticationContext.getUser(),
      }));
    }
    // console.log('Main: No user authenticated on startup');
    return Promise.resolve();
  }))
  .then(() => {
    // console.log('Main: Rendering Vue app');
    new Vue({
      router,
      store,
      i18n,
      icons,
      render: (h) => h(App),
    }).$mount('#app');
  })
  .catch((error) => {
    console.error('Main: Initialization error:');
    const appElement = document.getElementById('app');
    appElement.innerText = `Initialization failed: ${error.message || error}`;
  });
